import { cn } from "@be-miniapp/ui/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  )
}

interface LoadingSkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  isLoading: boolean
}

function LoadingSkeleton({
  isLoading,
  className,
  children,
  ...props
}: LoadingSkeletonProps) {
  return isLoading ? (
    <Skeleton className={cn("bg-gray-300", className)} {...props} />
  ) : (
    children
  )
}

export { Skeleton, LoadingSkeleton }
